import { useState } from "react";

import mindsquareLogo from "../../assets/mindsquare-logo.svg";

/**
 * Die Logo-Zeile der Bühne (D10): mindsquare-Logo, daneben das Logo des
 * Kunden, wenn eines hinterlegt ist.
 *
 * Beide stehen auf einer weißen Plakette (`.stage-logos`). Das mindsquare-
 * Logo ist grau mit Gelb und Orange und verschwände auf Navy oder einer
 * dunklen Kundenfarbe; Kundenlogos sind für die weiße Website gemacht und
 * haben oft keinen transparenten Rand. Weiß ist die eine Fläche, auf der
 * beide sicher tragen.
 *
 * Das Kundenlogo ist Zierde — lädt es nicht (gelöscht, Sitzung abgelaufen),
 * verschwindet es, statt ein gebrochenes Bild auf den Beamer zu legen
 * (Spec D5: nie ein Fehler). `alt=""`: Der Kundenname steht ohnehin in der
 * Kopfzeile.
 */
export function StageLogos({
  customerLogoUrl,
  size = "header",
}: {
  customerLogoUrl: string | null | undefined;
  size?: "header" | "large";
}) {
  return (
    <span className={`stage-logos stage-logos-${size}`} data-testid="stage-logos">
      <img src={mindsquareLogo} alt="mindsquare" className="stage-logo" />
      {customerLogoUrl ? <CustomerLogo key={customerLogoUrl} src={customerLogoUrl} /> : null}
    </span>
  );
}

/** Eigene Komponente, damit ein neuer `src` (per `key`) den Fehlerzustand zurücksetzt. */
function CustomerLogo({ src }: { src: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <>
      <span className="stage-logos-divider" aria-hidden="true" />
      <img src={src} alt="" className="stage-customer-logo" onError={() => setFailed(true)} />
    </>
  );
}
